import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { CompanyTrades } from "src/app/models/company-trades";
import { ApiService } from "src/app/services/api.service";
import { SignalRService } from "src/app/services/signalr.service";

@Component({
  selector: "app-quota-trade",
  templateUrl: "./quota-trade.component.html",
  styleUrls: ["./quota-trade.component.scss"],
})
export class QuotaTradeComponent implements OnInit {
  companyTrades: CompanyTrades;
  isTradesLoading: boolean;
  @Input() symbolCode: string;
  @Input() reuters: string;
  @Input() companyName: string;

  constructor(private _service: ApiService, signalService: SignalRService) {
    if (!this.isTradesLoading) {
      signalService.tradeChanges.subscribe((res) => {
        if (this.reuters != null) {
          res.forEach((element) => {
            if (element.reuters == this.reuters) {
              // this.fetchCompanyTrades();
            }
          });
        }
      });
    }
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    this.symbolCode = changes.symbolCode.currentValue;
    if (this.symbolCode) {
      this.isTradesLoading = true;
      this.fetchCompanyTrades();
    }
  }

  fetchCompanyTrades() {
    this.isTradesLoading = true;

    this._service.fetchCompanyTrades(this.symbolCode).subscribe((res) => {
      this.isTradesLoading = false;
      this.companyTrades = res as CompanyTrades;
    });
  }
}
